import { Icon, IconButton, IconButtonProps } from '@chakra-ui/react'
import { Delete } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useDeleteButtonStyle } from './componentStyles/DeleteButton.style'

type DeleteButtonProps = {
  handleHoldDelete: () => void
  handleDelete: () => void
} & Omit<IconButtonProps, 'aria-label'>
export const DeleteButton = ({
  handleDelete,
  handleHoldDelete,
  ...rest
}: DeleteButtonProps) => {
  const { t } = useTranslation()
  const styles = useDeleteButtonStyle()
  return (
    <IconButton
      css={styles.iconButton}
      aria-label={t('aria.backspace')}
      onMouseDown={handleHoldDelete}
      onMouseUp={handleDelete}
      onClick={(e) => {
        // Mouse clicks are handled by mouse down/up; detail is 0 for Enter/Space.
        if (e.detail === 0) handleDelete()
      }}
      {...rest}
    >
      <Icon css={styles.icon} as={Delete} />
    </IconButton>
  )
}
